import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import http from "@/api/http";
import axios from "axios";
var _process$env = process.env,
    VUE_APP_FY_BASE = _process$env.VUE_APP_FY_BASE,
    VUE_APP_FY_TFZB = _process$env.VUE_APP_FY_TFZB; // const VUE_APP_FY_BASE = "https://datacenter.istrongcloud.com"

export default {
  GetCityWarningData: function () {
    var _GetCityWarningData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(code, url) {
      var random, httpurl, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              random = new Date().getTime();
              httpurl = url || "".concat(VUE_APP_FY_BASE, "/data/allwarning/").concat(code, ".json?random=").concat(random); // const res = await axios.get(`${LOCAL_URL}data/warning/${code}.json?random=${random}`)

              _context.next = 5;
              return http.getStaticData(httpurl);

            case 5:
              res = _context.sent;
              return _context.abrupt("return", res.data);

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    function GetCityWarningData(_x, _x2) {
      return _GetCityWarningData.apply(this, arguments);
    }

    return GetCityWarningData;
  }(),
  GetCityWarningDataV2: function () {
    var _GetCityWarningDataV = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(code) {
      var random, res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              random = new Date().getTime(); // let res = await axios.get(`${LOCAL_URL}data/warning/${code}.json?random=${random}`);

              _context2.next = 4;
              return http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/citywarning/").concat(code, ".json?random=").concat(random));

            case 4:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", false);

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));

    function GetCityWarningDataV2(_x3) {
      return _GetCityWarningDataV.apply(this, arguments);
    }

    return GetCityWarningDataV2;
  }(),
  // 获取山洪预警
  getMountainTorrent: function () {
    var _getMountainTorrent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(params) {
      var res, random, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              res = null;
              _context3.prev = 1;
              random = new Date().getTime();
              _context3.next = 5;
              return http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/hydrology/warning/mountaintorrents/fj/").concat(params, ".json?random=").concat(random));

            case 5:
              data = _context3.sent;
              res = data.data;
              _context3.next = 12;
              break;

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](1);
              res = [];

            case 12:
              return _context3.abrupt("return", res);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 9]]);
    }));

    function getMountainTorrent(_x4) {
      return _getMountainTorrent.apply(this, arguments);
    }

    return getMountainTorrent;
  }(),
  // 获取洪水预警
  getFlood: function () {
    var _getFlood = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(params) {
      var res, random, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              res = null;
              _context4.prev = 1;
              random = new Date().getTime();
              _context4.next = 5;
              return http.getStaticData("".concat(VUE_APP_FY_BASE, "/data/hydrology/warning/flood/fj/").concat(params, ".json?random=").concat(random));

            case 5:
              data = _context4.sent;
              res = data.data;
              _context4.next = 12;
              break;

            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](1);
              res = [];

            case 12:
              return _context4.abrupt("return", res);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 9]]);
    }));

    function getFlood(_x5) {
      return _getFlood.apply(this, arguments);
    }

    return getFlood;
  }(),
  // 获取隐私协议
  getSystemPrivacy: function () {
    var _getSystemPrivacy = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var r, _yield$axios$get, res;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              r = new Date().getTime();
              _context5.next = 3;
              return axios.get("".concat(VUE_APP_FY_TFZB, "/data/des/21866.json?r=").concat(r));

            case 3:
              _yield$axios$get = _context5.sent;
              res = _yield$axios$get.data;
              return _context5.abrupt("return", res);

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function getSystemPrivacy() {
      return _getSystemPrivacy.apply(this, arguments);
    }

    return getSystemPrivacy;
  }()
};